import React, { FormEvent } from 'react'
import { Switch, Tag } from '@audio-network/componentlibrary'

import styles from './ExplicitFilter.module.css'
import { useToggleRefinement } from 'react-instantsearch'
import { useTranslation } from 'next-i18next'

const ExplicitFilter = (): JSX.Element => {
	const { t } = useTranslation(['search'])

	const { value, refine } = useToggleRefinement({
		attribute: 'Explicit',
		on: false,
	})

	const toggleExplicit = (event: FormEvent): void => {
		refine({ isRefined: !(event.target as HTMLInputElement).checked })
	}
	return (
		<Switch
			checked={value.isRefined}
			className={styles.switch}
			data-testid="explicit-switch"
			label={
				<>
					{t('hide-explicit')}
					<Tag
						data-testid="track-row-explicit"
						label="E"
						title="Explicit"
						color="ui4"
						round
					/>
				</>
			}
			onChange={toggleExplicit}
		/>
	)
}

export default ExplicitFilter
